import { useAuthContext } from 'components/Auth/AuthContextProvider'
import useCurrentLocale from 'lib/hooks/useCurrentLocale'

import useApiSWR, { ApiSWRResponse } from './useApiSWR'

interface GetProgressResponse {
  ProgressSlug: string | null
}

type UseGetProgress = (
  walkSlug: string,
  enabled?: boolean
) => ApiSWRResponse<GetProgressResponse>

const useGetProgress: UseGetProgress = (walkSlug, enabled) => {
  const { user } = useAuthContext()
  const locale = useCurrentLocale()

  const params = {
    UserID: user?.appUserId ?? null,
    WalkID: walkSlug,
    LanguageCode: locale,
  }

  const response = useApiSWR<GetProgressResponse>({
    method: 'GET',
    endpoint: '/api/Progress/GetProgressSlug',
    params,
    enabled,
    config: {
      revalidateOnFocus: false,
    },
  })

  if (process.env.NEXT_PUBLIC_USE_SSO !== 'true') {
    return { ...response, data: { ProgressSlug: null }, error: null }
  }

  return response
}

export default useGetProgress
